export default __webpack_public_path__ + "static/hero-95e90d222a34dc42217c1981a4485e6e.png";